<template>
  <div class="col pt-0 px-0">
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <slot name="pageTitle" v-if="hasDefaultPageTitle && !hasTableTitle">
      <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
        {{ modelNamePlural }}
      </div>
    </slot>

    <v-row>

      <v-col cols="12" class="">
        <v-data-table v-model="checkBoxSelectionListComputed" :search="search" :headers="tableHeaders"
          :items="computedTableItems" :item-class="itemClass" :sort-by="sortByField" :sort-desc="sortDesc"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100, 200]
          }" :items-per-page="itemsPerPage" :disable-pagination="disablePagination" class="elevation-1"
          :hide-default-footer="indexNested" :loading="loading" loading-text="Carregando..."
          :show-select="showCheckBoxSelectIndex" :single-select="showCheckBoxSingleSelectIndex" :id="tableId"
          loader-height="2" :options.sync="options" :server-items-length="serverItemsLength"
          @update:options="updateOptions" :show-expand="showExpand" @click:row="$emit('row-clicked', { ...arguments })"
          :custom-filter="tableCustomFilter" mobile-breakpoint="960" :no-data-text="noDataText" :item-key="itemKey"
          :style="[$vuetify.breakpoint.smAndDown ? { 'overflow-wrap': 'anywhere' } : {}]">
          <!-- @item-selected="itemSelectedEvent" -->
          <template v-for="(infoHeader, index) in infoHeaders" v-slot:[`header.${infoHeader.field}`]="{ header }">
            <v-tooltip top color="info" :key="infoHeader + index">
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="info" dark v-bind="attrs" v-on="on" small>
                  mdi-information-outline
                </v-icon>
              </template>
              <span>
                {{ infoHeader.info }}
              </span>
            </v-tooltip>
            {{ header.text}}
          </template>

          <template v-for="(maskField, index) in maskFields" v-slot:[`item.${maskField.field}`]="{ item }">
            <span v-if="maskField.mask == 'date'" v-bind:key="maskField.mask + item[maskField.field] + index">
              {{ _.get(item, maskField.field) | formatDate }}
            </span>
            <span v-if="maskField.mask == 'datetime'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatDateTime }}
            </span>
            <span v-if="maskField.mask == 'currency'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatCurrency }}
            </span>
            <span v-if="maskField.mask == 'currency_10d'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatCurrency_10d }}
            </span>
            <span v-if="maskField.mask == 'number'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatNumber }}
            </span>
            <span v-if="maskField.mask == 'number_unit'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <!-- unit.indexOf("^") > 0 ? (unit.split("^")[0] + "<sup>" + unit.split("^")[1] + "</sup>") : unit; -->
              {{ item[maskField.field] | formatNumber }} {{ maskField.unit.indexOf("^") > 0 ?
                maskField.unit.split("^")[0] : maskField.unit}}<sup
                v-if="maskField.unit.indexOf('^') > 0">{{ maskField.unit.split("^")[1] }}</sup>
            </span>
            <span v-if="maskField.mask == 'percentage'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatNumber }}%
            </span>
            <span v-if="maskField.mask == 'number_row_unit'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <!-- unit.indexOf("^") > 0 ? (unit.split("^")[0] + "<sup>" + unit.split("^")[1] + "</sup>") : unit; -->
              {{ item[maskField.field] | formatNumber }} {{ item[maskField.unit].indexOf("^") > 0 ?
                item[maskField.unit].split("^")[0] : item[maskField.unit]}}<sup
                v-if="item[maskField.unit].indexOf('^') > 0">{{ item[maskField.unit].split("^")[1] }}</sup>
            </span>
            <span v-if="maskField.mask == 'list'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{maskField.list.find(obj => obj[maskField.search] == item[maskField.field])[maskField.label]}}
            </span>
            <span v-if="maskField.mask == 'tag'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <v-chip class="ma-2" label :color="maskField.color" :outlined="maskField.outlined"
                v-for="(tag, index) in item[maskField.field]" v-bind:key="tag + item[maskField.field] + index">
                <!-- <v-icon left>mdi-server-plus</v-icon> -->
                {{ tag }}
              </v-chip>
            </span>
            <span v-if="maskField.mask == 'nice_boolean'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <v-icon :class="item[maskField.field] ? 'green--text' : ''">{{ item[maskField.field] ?
                'mdi-check-circle-outline' : 'mdi-checkbox-blank-circle-outline'}}</v-icon>
            </span>
            <span v-if="maskField.mask == 'color' && item[maskField.field]"
              v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <v-icon :color="item[maskField.field]" class="">mdi-circle</v-icon>
            </span>
            <span v-if="maskField.mask == 'color_with_text' && item[maskField.field]"
              v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <v-col cols="12" class="d-flex flex-column align-center justify-center text-center">
                <v-icon :color="item[maskField.field].hexaCode">mdi-circle</v-icon>
                  <span>{{ item[maskField.field].description }}</span>
              </v-col>
            </span>
            <span v-if="maskField.mask == 'status_color' && item[maskField.colorField]"
              v-bind:key="maskField.mask + '-' + item[maskField.field]">
              <v-chip class="mx-1" :color="item[maskField.colorField]" text-color="white">
                {{ item[maskField.field] }}
              </v-chip>
            </span>
            <span v-if="maskField.mask == 'nfe_serie'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatNfeSeries }}
            </span>
            <span v-if="maskField.mask == 'nfe_number'" v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ item[maskField.field] | formatNfeNumber }}
            </span>
            <span v-if="maskField.mask == 'blank_field_row_unit'" style="display: block; margin-top: 20px;"
              v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ "_____________" }} {{ item[maskField.unit] }}
            </span>
            <span v-if="maskField.mask == 'blank_field'" style="display: block; margin-top: 20px;"
              v-bind:key="maskField.mask + '-' + item[maskField.field]">
              {{ "_________________" }}
            </span>
          </template>

          <!-- <template v-for="field in currencyFields" v-slot:[`item.${field}`]="{ item }">
            <span>{{ item[field] | formatCurrency }} </span>
          </template> -->


          <template v-slot:top v-if="hasTopMenu">

            <div v-if="hasTableTitle">
              <v-row>
                <v-col cols="12" class="text-center pb-1">
                  <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
                    {{ tableTitle }}
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="col px-0" v-if="enableCustomFilters && !containTopToolbar">
              <div v-if="typeOperators.length > 0 && serverFields.length > 0">
                <BaseFilter :typeOperators="typeOperators" :serverFields="serverFields" :initialFilters="initialFilters"
                  v-on="$listeners" ref="baseFilter">
                  <template slot="actionBar">
                    <slot name="new"></slot>
                    <slot name="import"></slot>
                    <slot name="print"></slot>
                  </template>
                </BaseFilter>
              </div>

              <slot v-else name="custom_filters"></slot>

            </div>

            <div>
              <template>
                <slot name="filterSwitch"></slot>
              </template>

              <template>
                <slot name="filterText1"></slot>
              </template>
            </div>

            <v-toolbar flat v-if="containTopToolbar && !enableCustomFilters" class="mt-5">
              <v-text-field v-if="containSearchBar" v-model="search" append-icon="mdi-magnify" label="Pesquisar"
                single-line hide-details clearable class="mr-14 mr-sm-0"></v-text-field>

              <v-spacer></v-spacer>

              <slot name="index_action1"></slot>
              <slot name="index_action2"></slot>
              <slot name="index_action3"></slot>
              <slot name="index_action4"></slot>
              <slot name="index_action5"></slot>

              <slot name="new"></slot>
              <slot name="print"></slot>
            </v-toolbar>
          </template>

          <template v-slot:item.link="{ item }">
            <slot name="link1" v-bind:item="item"></slot>
            <slot name="link2" v-bind:item="item"></slot>
            <slot name="link3" v-bind:item="item"></slot>
          </template>

          <template v-slot:item.action="{ item }">
            <slot name="show" v-bind:item="item"></slot>
            <slot name="edit" v-bind:item="item"></slot>

            <slot name="delete" v-bind:item="item"></slot>

            <slot name="action1" v-bind:item="item"></slot>
            <slot name="action2" v-bind:item="item"></slot>
            <slot name="action3" v-bind:item="item"></slot>
            <slot name="action4" v-bind:item="item"></slot>
            <slot name="action5" v-bind:item="item"></slot>
            <slot name="action6" v-bind:item="item"></slot>
            <slot name="action7" v-bind:item="item"></slot>
            <slot name="action8" v-bind:item="item"></slot>
            <slot name="action9" v-bind:item="item"></slot>
            <slot name="action10" v-bind:item="item"></slot>
            <slot name="action11" v-bind:item="item"></slot>
            <slot name="action12" v-bind:item="item"></slot>
            <slot name="action13" v-bind:item="item"></slot>
          </template>

          <template v-slot:item.selected="{ item }">
            <v-switch v-model="item.selected" hide-details :disabled=showSelected(item)
              :label="`${item.selected ? 'Sim' : 'Não'}`" @change="changeSwitch(item)"></v-switch>
          </template>

          <template slot="body.prepend">
            <slot name="tableHeader"></slot>
          </template>

          <template slot="body.append">
            <slot name="tableFooter"></slot>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <slot name="expand" v-bind:headers="headers" v-bind:item="item"></slot>
          </template>

          <template v-slot:item.data-table-expand="{ item, isExpanded, expand }" v-if="customExpandIcon">
            <slot name="expandColumn" v-bind:item="item" v-bind:isExpanded="isExpanded" v-bind:expand="expand"></slot>
          </template>

        </v-data-table>

        <v-snackbar v-model="snackbarSuccess" :timeout="timeout" color="success" shaped>
          {{ confirmationMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbarSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-snackbar v-model="snackbarError" :timeout="timeout" color="error" shaped>
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="snackbarError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-bottom-sheet v-model="indexErrors.length" persistent>
          <v-sheet class="text-center">

            <div class="py-3">
              <p v-for="(error, index) in indexErrors" class="mb-0 mt-2 red--text" :key="error + index">
                {{ error }}
              </p>
            </div>
            <v-btn class="mt-6 mb-2" text color="black" @click="$emit('clear-index-errors')">Fechar</v-btn>
          </v-sheet>
        </v-bottom-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseFilter from "@shared_components/base_filter.vue";

export default {
  data() {
    return {
      search: "",
      snackbarSuccess: false,
      snackbarError: false,
      confirmationMessage: "",
      errorMessage: "",
      timeout: 10000,
      options: {},
      checkBoxSelectionList: []
    };
  },
  components: {
    BaseFilter: BaseFilter,
  },
  // watch: {
  //   options: {
  //     handler() {
  //       // console.log("options base index", this.options)
  //     }
  //   }
  // },
  computed: {
    computedTableItems() {
      return this.tableItems.filter((item) => !("_destroy" in item && item["_destroy"]))
    },
    checkBoxSelectionListComputed: {
      get() {
        // console.log("get", this.checkBoxSelectionList)
        return this.checkBoxSelectionList;
      },
      set(checkBoxSelectionList) {
        this.checkBoxSelectionList = checkBoxSelectionList;
        // console.log("set", checkBoxSelectionList, this.checkBoxSelectionList)
        this.$emit("checkBoxSelectionListChanged", checkBoxSelectionList);
      }
    }
  },
  props: {
    itemSelectedEvent: {
      type: Function,
      default: void (0)
    },
    loadOptions: {
      type: Object,
      default: () => { }
    },
    tableCustomFilter: {
      type: Function,
      default: (value, search, item) => {
        return value != null &&
          search != null &&
          typeof value !== 'boolean' &&
          value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1
      }
    },
    serverItemsLength: {
      type: Number,
      default: -1
    },
    itemsPerPage: {
      type: Number,
      default: 25
    },
    disablePagination: {
      type: Boolean,
      default: false
    },
    enableCustomFilters: {
      type: Boolean,
      default: false
    },
    showExpand: {
      type: Boolean,
      default: false
    },
    customExpandIcon: {
      type: Boolean,
      default: false
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    hasTopMenu: {
      type: Boolean,
      default: true,
    },
    hasDefaultPageTitle: {
      type: Boolean,
      default: true
    },
    modelNameSingular: {
      type: String,
      default: "Registro"
    },
    modelNamePlural: {
      type: String,
      default: "Registros"
    },
    tableTitle: {
      type: String,
      default: function () {
        return this.modelNamePlural
      }
    },
    tableHeaders: {
      type: Array,
      default: () => []
    },
    tableItems: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: true
    },
    pageLoading: {
      type: Boolean,
      default: false
    },
    itemClass: {
      type: Function,
      default: () => null
    },
    showCheckBoxSelectIndex: {
      type: Boolean,
      default: false
    },
    showCheckBoxSingleSelectIndex: {
      type: Boolean,
      default: false
    },
    maskFields: Array,
    infoHeaders: Array,
    indexNested: {
      type: Boolean,
      default: false
    },
    containSearchBar: {
      type: Boolean,
      default: true
    },
    containTopToolbar: {
      type: Boolean,
      default: true
    },
    sortByField: {
      type: String
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    tableId: {
      type: String
    },
    noDataText: {
      type: String,
      default: "Não há dados disponíveis"
    },
    itemKey: {
      type: String,
      default: "id"
    },
    indexErrors: {
      type: Array,
      default: () => []
    },
    typeOperators: {
      type: Array,
      default: () => []
    },
    serverFields: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    initialFilters: {
      type: Array,
      default: () => []
    },
    changeSwitch: {
      type: Function,
      default: () => null,
    },
    showSelected: {
      type: Function,
      default: (item) => {
        if (item.__typename == "SaleOrder" && item.status == 1) {
          // console.log("aquiii");
          return true
        }
        else if (item.__typename == "Nfe" && (item.statusKey != "authorized" || item.hasMdfe)) {
          return true
        }
        else {
          return false;
        }
      }
    },
  },
  methods: {
    showConfirmationUpdateMessage: function (message = null) {
      if (message) {
        this.showConfirmationMessage(message);
      } else {
        let recordName = this.modelNameSingular.toLowerCase();
        let automaticMessage = "Registro de " + recordName + " atualizado com sucesso!"
        this.showConfirmationMessage(automaticMessage);
      }
    },
    showConfirmationCreateMessage: function (message = null) {
      if (message) {
        this.showConfirmationMessage(message);
      } else {
        let recordName = this.modelNameSingular.toLowerCase();
        let automaticMessage = "Registro de " + recordName + " criado com sucesso!"
        this.showConfirmationMessage(automaticMessage);
      }
    },
    showConfirmationDeleteMessage: function (message = null) {
      if (message) {
        this.showConfirmationMessage(message);
      } else {
        let recordName = this.modelNameSingular.toLowerCase();
        let automaticMessage = "Registro de " + recordName + " removido com sucesso!"
        this.showConfirmationMessage(automaticMessage);
      }
    },
    showConfirmationMessage: function (message) {
      this.snackbarSuccess = true;
      this.confirmationMessage = message;
    },
    showErrorMessage: function (message) {
      this.snackbarError = true;
      this.errorMessage = message;
    },
    updateOptions: function (newOptions) {
      this.$emit('options-change', newOptions);
    },

    // showSelected: function (item) {
    //   // console.log('item', item);
    //   if (item.__typename == "SaleOrder" && item.status == 1) {
    //     // console.log("aquiii");
    //     return true
    //   }
    //   else if (item.__typename == "Nfe" && (item.statusKey != "authorized" || item.hasMdfe)) {
    //     return true
    //   }
    //   else {
    //     return false;
    //   }
    // },
  },
  created() {
    this.options = this.loadOptions;
  }
};
</script>

<style scoped>
::v-deep .v-data-table--mobile .v-data-footer__select {
  margin-left: auto;
  margin-right: auto;
}

::v-deep .v-data-table--mobile .v-data-footer__select .v-select {
  margin-left: 5px;
}

::v-deep .v-data-table--mobile .v-data-footer__pagination {
  margin-left: auto;
  margin-right: auto;
}

.v-input {
  margin-top: 0px;
}
</style>
